import { FormControl, FormField as ShadcnFormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Password } from "@/components/ui/password"
import { useTranslation } from "react-i18next"
import { Path, type FieldValues, type UseFormReturn } from "react-hook-form"

interface MezzaPasswordFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>
  name: keyof T
  label?: string
  placeholder?: string
  className?: string
  disabled?: boolean
  autoFocus?: boolean
  onMouseDown?: (e: React.MouseEvent<HTMLInputElement>) => void
}

export function MezzaPasswordField<T extends FieldValues>({
  form,
  name,
  label,
  placeholder,
  className,
  disabled,
  autoFocus,
  onMouseDown,
}: MezzaPasswordFieldProps<T>) {
  const { t } = useTranslation()
  
  return (
    <ShadcnFormField
      control={form.control}
      name={name as Path<T>}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{t(label)}</FormLabel>}
          
          <FormControl>
            <Password
              autoFocus={autoFocus}
              onMouseDown={onMouseDown}
              placeholder={placeholder ? t(placeholder) : undefined}
              className={className}
              {...field}
              disabled={disabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

